var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.3;}\r\n\t.st1{opacity:0.3;fill:#00C650;enable-background:new    ;}\r\n\t.st2{fill:#00C650;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.64,108.6c-11.39-0.01-22.31-4.54-30.36-12.59c-8.05-8.05-12.58-18.97-12.59-30.36V6H103.76 C96.39,6,89.1,7.45,82.3,10.26c-6.8,2.82-12.99,6.94-18.19,12.15c-5.21,5.21-9.34,11.39-12.16,18.19 c-2.82,6.8-4.27,14.09-4.27,21.46V400c0,7.36,1.45,14.66,4.27,21.46c2.82,6.8,6.95,12.98,12.16,18.19 c5.21,5.21,11.39,9.34,18.19,12.15c6.8,2.82,14.1,4.26,21.46,4.26h230.41c14.87,0,29.13-5.91,39.64-16.42 c10.51-10.51,16.42-24.77,16.42-39.64V108.6H338.64z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M390.22,108.6h-51.58c-11.39-0.01-22.31-4.54-30.36-12.59c-8.05-8.05-12.58-18.97-12.59-30.36V6L390.22,108.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M430.87,361.42H170.38c-18.48,0-33.46,14.98-33.46,33.46v77.66c0,18.48,14.98,33.46,33.46,33.46h260.49 c18.48,0,33.46-14.98,33.46-33.46v-77.66C464.32,376.4,449.35,361.42,430.87,361.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M295.35,320.22H142.55c-13.23,0-23.98-13.17-23.98-29.37V179.97c0-16.19,10.75-29.35,23.98-29.35h152.81 c13.23,0,23.98,13.17,23.98,29.35v110.81C319.33,306.99,308.58,320.22,295.35,320.22z M142.55,165.7 c-6.46,0-11.71,6.42-11.71,14.33v110.81c0,7.92,5.25,14.35,11.71,14.35h152.81c6.46,0,11.73-6.44,11.73-14.35V179.97 c0-7.92-5.27-14.33-11.73-14.33L142.55,165.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M313.21,253.43H124.69v15.02h188.51V253.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M313.21,201.91H124.69v15.02h188.51V201.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M264.94,158.12h-15.02v154.51h15.02V158.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.98,158.12h-15.02v154.51h15.02V158.12z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M176.63,458.11h10.6v10.6h-10.6V458.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M205.43,398.71h30v10h-19v18.5h15.1v10h-15.1v21.5h19v10h-30V398.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M261.62,432.91l-12.1-34.2h11.6l7.4,22.6h0.2l7.6-22.6h10.4l-12.1,34.2l12.7,35.8h-11.6l-8-24.4h-0.2 l-8.2,24.4h-10.4L261.62,432.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M304.37,465.21c-2.77-3-4.15-7.23-4.15-12.7v-37.6c0-5.46,1.38-9.7,4.15-12.7c2.77-3,6.78-4.5,12.05-4.5 c5.27,0,9.28,1.5,12.05,4.5c2.77,3,4.15,7.23,4.15,12.7v7.4h-10.4v-8.1c0-4.33-1.83-6.5-5.5-6.5c-3.67,0-5.5,2.17-5.5,6.5v39.1 c0,4.27,1.83,6.4,5.5,6.4c3.67,0,5.5-2.13,5.5-6.4v-10.7h10.4v9.9c0,5.47-1.38,9.7-4.15,12.7c-2.77,3-6.78,4.5-12.05,4.5 C311.16,469.71,307.14,468.21,304.37,465.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M349.22,398.71h30v10h-19v18.5h15.1v10h-15.1v21.5h19v10h-30V398.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M395.52,398.71h11v60h18.1v10h-29.1V398.71z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel-icon.6e147683d01218de9cd688e08ef1c915.svg";
export { ForwardRef as ReactComponent };